import React from "react";
import { v4 as uuidv4 } from "uuid";

import NameHeader from "../shared/NameHeader";
import Summary from "../shared/Summary";

import * as CONSTANTS from "../../utilities/Constants";

import ReportTemplateViewData, { defaultReportTemplateData } from "../../models/reportTemplate/ReportTemplateViewData";
import reportTemplateByIdStore from "../../flux/stores/reportTemplate/ByIdStore";

interface ILandingState {
   reportTemplateData: ReportTemplateViewData;
}

export default class Landing extends React.Component<{}, ILandingState> {
  private _mount: boolean = false;

  constructor(props: {}) {
    super(props);
    this._mount = true;
    this.state = {
      reportTemplateData: defaultReportTemplateData
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    reportTemplateByIdStore.on(CONSTANTS.CHANGE_EVENT, state => {
      if (this._mount) {
        this.setState({ reportTemplateData: state.reportTemplateData });
      }
    });
  }

  public render() {
    
    return (
      <div className="page-layout">
        <NameHeader authKey={CONSTANTS.AUTHKEY_REPORT_TEMPLATE} data={this.state.reportTemplateData.name} />

        <Summary>
          <div className="page-scroll">
            <div className="row mt-3">
              <div className="col-md-12">
                <span className="summary-label">
                  {this.state.reportTemplateData.descriptionLabel}:
                  </span>
                <span className="summary-value ml-2">
                  {this.state.reportTemplateData.description}
                </span>
              </div>
          </div>
         </div> 
        </Summary>
      </div>
    );
  }
}
